<template>
  <div class="main-content">
    <div class="roll-call-page">
      <div class="container">
        <div class="function-bar">
          <h3 class="function-bar__title">課程點名</h3>
          <DatePicker
            ref="datePicker"
            :format="'YYYY-MM-DD'"
            placeholder="請選擇起始日 - 請選擇截止日"
            v-model="datePick"
            type="date"
            valueType="YYYY-MM-DD"
            :append-to-body="false"
            :clearable="false"
          >
            <div slot="input" class="fake-input">
              <span class="icon-icon_calendar"></span>
              <p>{{ this.datePick }}</p>
              <span class="icon-arrow_d-1 ml-auto"></span>
            </div>
          </DatePicker>

          <button class="qr-btn custom-btn" @click="generatePdf">
            本日QRcode下載
          </button>
        </div>

        <ul class="location-menu">
          <Location
            v-for="(oneLocation, index) in locationOptions"
            :key="index"
            :oneLocation="oneLocation"
            v-model="location"
          />
        </ul>

        <div class="course-area">
          <div class="course-area__day">
            <OneCourse
              v-for="(schedule, index) in morningSchedules"
              :key="index"
              :schedule="schedule"
              :date="datePick"
            />
          </div>

          <div class="course-area__night">
            <OneCourse
              v-for="(schedule, index) in eveningSchedules"
              :key="index"
              :schedule="schedule"
              :date="datePick"
            />
          </div>
        </div>
      </div>
    </div>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :paginate-elements-by-height="1400"
      :filename="datePick"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div v-for="(schedule, index) in exportSchedules" :key="index">
          <div class="container">
            <div class="row">
              <div class="col-5 export-course-area">
                <div class="export-course-block">
                  <p>{{ schedule.start_at }}-{{ schedule.end_at }}</p>
                  <p :style="`color:${schedule.course.color_code}`">
                    {{ schedule.course.name }}
                  </p>

                  <p>{{ schedule.user.name }}</p>
                </div>
              </div>

              <div class="col-7">
                <CheckInQrCode
                  :schedule-time-id="schedule.schedule_time_id"
                  :date="datePick"
                  :width="300"
                ></CheckInQrCode>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <div v-if="(index + 1) % 3 == 0" class="html2pdf__page-break"></div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import moment from 'moment';
import Location from '@/components/RollCallInside/Location';
import OneCourse from '@/components/RollCallInside/OneCourse';
import { fetchBranches, fetchBranchSchedules } from '@/api/branch';
import VueHtml2pdf from 'vue-html2pdf';
import CheckInQrCode from '@/components/QrCode/CheckInQrCode';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      datePick: moment().format('YYYY-MM-DD'),
      location: '',
      locationOptions: [],
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'initial-scale=1.0'
      },
      path: this.$route.path,
      morningSchedules: [],
      eveningSchedules: []
    };
  },
  components: {
    OneCourse,
    Location,
    VueHtml2pdf,
    CheckInQrCode
  },
  computed: {
    ...mapGetters('user', ['branchId']),
    exportSchedules() {
      return this.morningSchedules.concat(this.eveningSchedules);
    }
  },
  watch: {
    branchId() {
      this.setDefaultBranch();
    },
    location() {
      if (this.datePick) {
        this.fetchBranchSchedules(this.datePick, this.location);
      }
    },
    datePick() {
      if (this.location) {
        this.fetchBranchSchedules(this.datePick, this.location);
      }
    }
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);

    this.fetchBranches();

    this.setDefaultBranch();
  },
  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    },
    fetchBranches() {
      fetchBranches(branches => {
        this.locationOptions = branches;
      });
    },
    fetchBranchSchedules(date, branchId) {
      fetchBranchSchedules({ date, branchId }, schedulesSession => {
        this.morningSchedules = schedulesSession['morning'];

        this.eveningSchedules = schedulesSession['evening'];
      });
    },
    async generatePdf() {
      let loader = await this.$loading.show();

      await this.$refs.html2Pdf.generatePdf();

      loader.hide();
    },
    setDefaultBranch() {
      if (this.branchId != undefined) {
        this.location = this.branchId;
      }
    },
    resetExportParams() {
      this.exportSchedules = [];
    }
  }
};
</script>

<style>
.export-course-block {
  width: 150px;
  height: 150px;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-bottom: 10px;
  margin: 0 auto;
  padding: 30px 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.export-course-area {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-right: -40px;
  margin-left: -40px;
}
</style>
